import { Dropdown, Popconfirm, theme } from 'antd'
import i18n from 'i18next'
import { useState } from 'react'
import { AiOutlineDelete } from 'react-icons/ai'
import { BiEdit, BiShowAlt } from 'react-icons/bi'
import { RxHamburgerMenu } from 'react-icons/rx'

import styles from './ItemCrudDropdown.module.css'

import type { CrudContextLike, DepartmentNodeData } from '../../Contracts/DepartmentTree.types'

const { useToken } = theme

interface ItemCrudDropdownProps {
    crudContext?: CrudContextLike | undefined
    item: DepartmentNodeData
}

const ItemCrudDropdown = ({ crudContext, item }: ItemCrudDropdownProps) => {
    const { token } = useToken()
    const [isOpen, setIsOpen] = useState(false)

    if (!crudContext) {
        return null
    }

    const generateMenuItems = () => {
        const menuItems = []

        if (crudContext.accessManager?.isCan('read') && crudContext.actions?.view) {
            menuItems.push({
                icon: <BiShowAlt style={{ fontSize: 18 }} />,
                label: i18n.t('View', { ns: 'Core' }),
                onClick: () => {
                    crudContext.actions?.view?.(item)
                    setIsOpen(false)
                },
                key: 'view',
            })
        }

        if (crudContext.accessManager?.isCan('update', item) && crudContext.actions?.edit) {
            menuItems.push({
                icon: <BiEdit style={{ fontSize: 18 }} />,
                label: i18n.t('Edit', { ns: 'Core' }),
                onClick: () => {
                    crudContext.actions?.edit?.(item)
                    setIsOpen(false)
                },
                key: 'edit',
            })
        }

        if (crudContext.accessManager?.isCan('delete', item) && crudContext.actions?.delete) {
            menuItems.push({
                icon: <AiOutlineDelete style={{ fontSize: 18, color: token.colorError }} />,
                label: (
                    <Popconfirm
                        title={i18n.t('Delete', { ns: 'Core' })}
                        description={i18n.t('Do you really want to delete?', { ns: 'Core' })}
                        onConfirm={() => crudContext.actions?.delete?.(item.id)}
                        okText={i18n.t('Yes', { ns: 'Core' })}
                        cancelText={i18n.t('No', { ns: 'Core' })}
                    >
                        {i18n.t('Delete', { ns: 'Core' })}
                    </Popconfirm>
                ),
                key: 'delete',
            })
        }

        return menuItems
    }

    const menuItems = generateMenuItems()

    if (!menuItems.length) return null

    return (
        <div className={styles['styledLink']} onPointerDown={(e) => e.stopPropagation()}>
            <Dropdown
                menu={{
                    items: menuItems.map(({ label, icon, onClick, key }) => ({
                        key,
                        label: (
                            <div
                                onClick={(e) => {
                                    e.stopPropagation()
                                    if (onClick) onClick()
                                }}
                                style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                            >
                                {icon} {label}
                            </div>
                        ),
                    })),
                }}
                trigger={['click']}
                open={isOpen}
                onOpenChange={(open) => setIsOpen(open)}
            >
                <a
                    onClick={(e) => e.preventDefault()}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <RxHamburgerMenu style={{ fontSize: 20, color: token.colorPrimary }} />
                </a>
            </Dropdown>
        </div>
    )
}

export default ItemCrudDropdown
